import { httpGet, httpPost } from './api.service';

export const getTemplates = async () => {
  return await httpGet('/api/email/template');
};

export const getSubjectBody = async (code: string) => {
  return await httpGet(`/api/email/template/${code}/en`);
};

export const updateSubjectBody = async (code: string, subject: string, body: string) => {
  const response: any = await httpPost(`/api/email/template/${code}/en`, { subject, body });
  if (response?.status >= 400) {
    throw new Error(response?.data || response?.errorMessage || 'Update failed');
  }
  return response;
};

export const getSignOff = async () => {
  return await httpGet(`/api/email/template/signoff/en`);
};

export const updateSignOff = async (contents: string) => {
  const response: any = await httpPost(`/api/email/template/signoff/en`, { contents });
  if (response?.status >= 400) {
    throw new Error(response?.data || response?.errorMessage || 'Update failed');
  }
  return response;
};
